/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-05 11:17:08
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\store\modules\routes.js
 */
/**
 * @Author: WeiZisen
 * @Date: 2021-03-15 11:13:04
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-05-28 10:22:50
 * @Description: 请输入一段描述
 * @FilePath: \Vue_RebarProcess\src\store\modules\routes.js
 */
/**
 * @description 路由拦截状态管理，目前两种模式：all模式与intelligence模式，其中partialRoutes是菜单暂未使用
 */
import { asyncRoutes, constantRoutes, resetRouter } from '@/router'
import { dataFn, routesdata } from '@/router/data'
import { convertRouter, filterRoutes } from '@/utils/routes'
import { treeData } from '@/utils/index'
//状态：存放一些通用的属性 保存的就是公共状态
const state = { routes: [], partialRoutes: [] }
/*getters属性理解为所有组件的computed属性,
也就是计算属性.
vuex的官方文档也是说到可以将getter理解为store的计算属性,
 getters的返回值会根据它的依赖被缓存起来，
 且只有当它的依赖值发生了改变才会被重新计算。
*/
const getters = {
  routes: (state) => state.routes,
  partialRoutes: (state) => state.partialRoutes,
}
//改变state的唯一方式就是通过mutations进行更改
//mutaions理解为store中的methods,
// mutations对象中保存着更改数据的回调函数,
// 该函数名官方规定叫type,
// 第一个参数是state,
//  第二参数是payload,
//  也就是自定义的参数.

const mutations = {
  setRoutes(state, routes) {
    state.routes = routes
  },
  setPartialRoutes(state, routes) {
    state.partialRoutes = routes
  },
}
//actions 类似于 mutations，不同在于：
// actions提交的是mutations而不是直接变更状态
// actions中可以包含异步操作, mutations中绝对不允许出现异步
// actions中的回调函数的第一个参数是context, 是一个与store实例具有相同属性和方法的对象
const actions = {
  /**
   * @description 多模式设置路由(默认前端路由,未使用模式可删除相应代码即可)
   * @param {*} { commit }
   * @param mode
   * @returns
   */
  async setRoutes({ state, commit }, mode = 'intelligence') {
    let test1 = await dataFn() //假接口 这里已经写死在路由data文件中
    // let test1 = routesdata
    let test2 = JSON.parse(JSON.stringify(test1)) //这里为什么要转一次？没明白
    let routes = convertRouter(test2)
    const accessRoutes = filterRoutes([...constantRoutes, ...routes])
    //调用 mutations中的方法，改变state中的routes
    commit('setRoutes', accessRoutes)
    // 根据可访问路由重置Vue Router
    await resetRouter(accessRoutes)
  },
  /**
   * @description 画廊布局、综合布局设置路由
   * @param {*} { commit }
   * @param accessedRoutes 画廊布局、综合布局设置路由
   */
  setPartialRoutes({ commit }, accessedRoutes) {
    commit('setPartialRoutes', accessedRoutes)
  },
}
export default { state, getters, mutations, actions }
